import ChevronLeft from "./assets/chevron-left.svg";
import CheckCircle from "./assets/check-circle.svg";
const svgs = {
  ChevronLeft,
  CheckCircle,
};

export default svgs;
